<template>
  <div>
    <callout
      :class-main="'callout-' + getStatusClass(model.statusId)"
      class="my-3"
      :controlled="true"
      :has-toggle="true"
      :opened="model.isOpen"
      @click:open="openCalloutHandler"
    >
      <div class="row py-1 font-weight-normal row-align-left">
        <div
          class="
            col-md-2
            mb-md-0 mb-2
            align-self-stretch
            border-right
            d-flex
            justify-content-center
            align-items-center
          "
        >
          <div
            :class="['activity-indicator px-5', getStatusClass(model.statusId)]"
          >
            {{ model.status || '-' }}
          </div>
        </div>

        <div class="col-md-2 mb-md-0 mb-2">
          <div class="color-secondary-6 font-14">Nombre del Solicitante:</div>
          <div class="color-black font-16">
            {{ model.userFullName || '-' }}
          </div>
        </div>

        <div class="col-md-2 mb-md-0 mb-2">
          <div class="color-secondary-6 font-14">Aplicación:</div>
          <div class="color-black font-16">
            {{ model.application || '-' }}
          </div>
        </div>

        <div class="col-md-2 mb-md-0 mb-2">
          <div class="color-secondary-6 font-14">Rol:</div>
          <div class="color-black font-16">
            {{ model.role || '-' }}
          </div>
        </div>

        <div class="col-md-2 mb-md-0 mb-2">
          <div class="color-secondary-6 font-14">Nombre de Usuario:</div>
          <div class="color-black font-16">
            {{ model.username || '-' }}
          </div>
        </div>

        <div
          class="
            col-md-2
            mb-md-0 mb-2
            d-flex
            justify-content-md-end justify-content-center
            pr-5
          "
        >
          <dropdown
            v-if="hasActionsPermission"
            class="actions-dropdown"
            :items="actionItems(model)"
            title="Acciones"
          />
        </div>
      </div>

      <template slot="edition">
        <validation-observer ref="reasonForm">
          <div class="bg-secondary-3 mt-1 p-1 rounded font-weight-normal">
            <div class="row mx-0 p-3 bg-white" v-if="!noStatusChange">
              <div class="col-12 mb-1">
                <em
                  class="fas color-orange"
                  :class="{
                    'fa-times-circle':
                      checkInteractionMode(userRequestStatuses.Denegada) ||
                      checkInteractionMode(userRequestStatuses.Cancelada),
                    'fa-flag-alt': checkInteractionMode(
                      userRequestStatuses.Aprobada
                    ),
                  }"
                />
                <span class="reason-title">
                  {{ getTitleMode }}
                </span>
              </div>
              <div
                v-if="checkInteractionMode(userRequestStatuses.Aprobada)"
                class="col-12 col-md-8 mt-3 pl-4 row mx-0"
              >
                <div class="col-12 col-md-6 mb-md-0 mb-3">
                  <validation-provider
                    rules="required"
                    v-slot="{ errors }"
                    vid="usernameVP"
                    :custom-messages="{
                      required: 'El usuario es requerido.',
                    }"
                  >
                    <custom-input
                      v-model="approveModel.username"
                      label="Nombre del Usuario:"
                      maxlength="64"
                      :disabled="readonly || model.username !== null"
                      :error="errors[0]"
                    />
                  </validation-provider>
                </div>
                <div class="pl-md-5 col-md-6 col-12 mb-md-0 mb-3">
                  <validation-provider rules="required" v-slot="{ errors }">
                    <custom-radio
                      v-model="approveModel.authMode"
                      class="inline-grey-radio"
                      :options="authModeOptions"
                      name="authMode"
                      label="Autenticación:"
                      :error="errors[0]"
                      is-inline
                      custom-error-msg="La autentificación es requerida."
                    />
                  </validation-provider>
                </div>
              </div>
              <div v-else class="col-12 pl-md-4">
                <validation-provider rules="required" v-slot="{ errors }">
                  <custom-text-area
                    :maxlength="3000"
                    class="custom__text-area"
                    :count-classes="['d-block', 'small-counter']"
                    v-model="reason"
                    show-char-count
                    :error="errors[0]"
                    :custom-error-msg="
                      checkInteractionMode(userRequestStatuses.Cancelada)
                        ? 'Favor escriba la razón de cancelación.'
                        : 'Favor escriba la razón de denegación.'
                    "
                    name="comment"
                    id="comment"
                    :disabled="readonly"
                  />
                </validation-provider>
              </div>

              <template v-if="!readonly">
                <div
                  class="
                    col-12
                    mt-3
                    d-flex
                    flex-column flex-md-row
                    justify-content-md-end
                  "
                  :class="{
                    'col-md-4 align-self-center': checkInteractionMode(
                      userRequestStatuses.Aprobada
                    ),
                  }"
                >
                  <action-button
                    variant="outline-danger mb-2 mb-md-0 mr-md-2"
                    text="Cancelar"
                    i="fas fa-times-circle"
                    @click="onCancel"
                  />
                  <action-button
                    variant="success"
                    text="Guardar"
                    i="fas fa-save"
                    @click="onSave"
                  />
                </div>
              </template>
            </div>
            <div v-if="noStatusChange" class="bg-white" >
              <custom-tab class="profile-tabs">
                <custom-tab-item title="Historial de usuario" :lazy="false">
                  <div class="ml-3 mt-4">
                    <div class="row">
                      <div class="col-12 mb-1">
                        <em class="fas color-orange fa-clock" />
                        <span class="reason-title">Historial de usuario</span>
                      </div>
                    </div>
                 
                      
                    <time-line class="mt-4 col-11 mx-auto px-0">
                        <time-line-item
                        class="custom-time-line rounded"
                         v-if="historyItems.length === 0 && model.statusId==userRequestStatuses.Sometida"
                      >
                        <div class="row ml-5">
                          <div class="col-md-3">
                            <p class="mb-0 color-gray-6 text-small">
                              Autorizado por:
                            </p>
                            <b>{{ model.requesterFullName }}</b>
                          </div>
                          <div class="col-md-3">
                            <p class="mb-0 color-gray-6 text-small">Usuario:</p>
                            <b>{{ model.userFullName }}</b>
                          </div>
                          <div class="col-md-3">
                            <p class="mb-0 color-gray-6 text-small">Rol:</p>
                            <b>{{ model.role }}</b>
                          </div>
                          <div class="col-md-3">
                            <p class="mb-0 color-gray-6 text-small">Estatus:</p>
                            <div class="row">
                              <div class="col-5 d-flex justify-content-start">
                                <span
                                  class="circle-indicator mr-2"
                                  :class="`container-status ${getStatusClass(
                                    model.statusId
                                  )}`"
                                ></span>
                                {{ getStatusName(model.statusId) }}
                              </div>
                            </div>
                          </div>
                        </div>
                        <template #icon>
                          <em
                            :class="`fas fa-user text-white fa-lg font-15`"
                            class="radius"
                          />
                        </template>
                        <template #date>
                          <div class="date-container">
                            <div
                              class="
                                color-black
                                font-16 font-weight-bold
                                fulldate
                              "
                            >
                              {{ model.requestedDate | date }}
                              <small>{{ model.requestedDate | hour }}</small>
                            </div>
                          </div>
                        </template>
                      </time-line-item>
                    <div   v-for="(item, index) in historyItems"  :key="index">
                        <time-line-item
                        class="custom-time-line rounded"
                       
                      >
                        <div class="row ml-5">
                          <div class="col-md-3" v-if="item.previusStatus!=userRequestStatuses.Nueva">
                            <p class="mb-0 color-gray-6 text-small">
                               {{ getStatusName(item.status) }} por:
                            </p>
                            <b>{{ item.userCreator }}</b>
                          </div>
                          <div class="col-md-3" v-else>
                            <p class="mb-0 color-gray-6 text-small">
                              Autorizado por:
                            </p>
                            <b>{{ item.authorizedby }}</b>
                          </div>
                          <div class="col-md-3">
                            <p class="mb-0 color-gray-6 text-small">Usuario:</p>
                            <b>{{ item.user }}</b>
                          </div>
                          <div class="col-md-3">
                            <p class="mb-0 color-gray-6 text-small">Rol:</p>
                            <b>{{ item.rol }}</b>
                          </div>
                          <div class="col-md-3">
                            <p class="mb-0 color-gray-6 text-small">Estatus:</p>
                            <div class="row">
                              <div class="col-5 d-flex justify-content-start">
                                <span
                                  class="circle-indicator mr-2"
                                  :class="`container-status ${getStatusClass(
                                    item.status
                                  )}`"
                                ></span>
                                {{ getStatusName(item.status) }}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          v-if="item.status == userRequestStatuses.Denegada"
                          class="bg-white p-3 mt-4 ml-6"
                        >
                          <div class="row">
                            <div class="col-md-3">
                              <p class="mb-0 color-gray-6 text-small">Razón:</p>
                              <b>{{ item.reason }}</b>
                            </div>
                          </div>
                        </div>
                        <template #icon>
                          <em
                            :class="`fas fa-user text-white fa-lg font-15`"
                            class="radius"
                          />
                        </template>
                        <template #date>
                          <div class="date-container">
                            <div
                              class="
                                color-black
                                font-16 font-weight-bold
                                fulldate
                              "
                            >
                              {{ item.previusStatus!=userRequestStatuses.Nueva? item.updatedDate : item.date  | date }}
                              <small>{{  item.previusStatus!=userRequestStatuses.Nueva? item.updatedDate : item.date | hour }}</small>
                            </div>
                          </div>
                        </template>
                      </time-line-item>
                    </div>
                      <custom-result-not-found
                        v-if="historyItems.length === 0 && !model.statusId==userRequestStatuses.Sometida"
                      />
                    </time-line>
                    
                    <br />
                  </div>
                  <div
                    v-if="count > 3"
                    class="
                      d-flex
                      justify-content-center
                      align-items-center
                      mt-3
                    "
                  >
                    <action-button
                      class="btn-see-more"
                      i="fas fa-chevron-down"
                      text="Ver más"
                      variant="outline-success rounded-pill px-5 mb-4"
                      @click="onLoadMoreHandler"
                    />
                  </div>
                </custom-tab-item>
              </custom-tab>
            </div>
          </div>
        </validation-observer>
      </template>
    </callout>
  </div>
</template>

<script>
import Callout from 'custom-callout';
import Dropdown from 'dropdown';
import CustomTextArea from 'CustomTextArea';
import CustomInput from 'CustomInput';
import ActionButton from 'ActionButton';
import CustomRadio from '@/components/common/CustomRadio';
import userRequestStatuses from '@/utils/constants/userRequestStatuses';
import { authModeOptions } from '@/utils/constants/authenticationModes.js';
import alert from 'utils/mixins/alert.mixin';
import { TimeLine, TimeLineItem } from '@quisit/mipe-timeline';
import CustomTab from 'custom-tabs/src/CustomTab';
import CustomTabItem from 'custom-tabs/src/CustomTabItem';
import CustomResultNotFound from 'custom-result-not-found';
const DEFAULT_HISTORY_STATUS_PAGE_SIZE = 3;

import { getHistory as _getHistory } from '@/modules/userRequest/api';
export default {
  name: 'ResultRow',
  components: {
    Callout,
    Dropdown,
    CustomTextArea,
    ActionButton,
    CustomInput,
    TimeLine,
    TimeLineItem,
    CustomRadio,
    CustomTab,
    CustomTabItem,
    CustomResultNotFound,
  },
  mixins: [alert],
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    hasActionsPermission: {
      type: Boolean,
      default: () => true,
    },
  },
  data() {
    return {
      approveModel: {
        username: null,
        authMode: null,
      },
      reason: '',
      interactionMode: null,
      userRequestStatuses,
      authModeOptions,
      historyItems: [],
      count: null,
      pageSize: DEFAULT_HISTORY_STATUS_PAGE_SIZE,
    };
  },
  computed: {
    model() {
      return this.value;
    },
    canOpenCallout() {
      return [
        userRequestStatuses.Sometida,
        userRequestStatuses.Aprobada,
        userRequestStatuses.Cancelada,
        userRequestStatuses.Denegada,
      ].includes(this.model.statusId);
    },

    actionItems() {
      let allAction = [
        {
          label: 'Aprobar',
          icon: 'fas fa-check-circle text-green mr-2',
          visible: this.canApprove,
          click: () => this.onChangeStatus(userRequestStatuses.Aprobada),
        },

        {
          label: 'Denegar',
          icon: 'fas fa-ban text-danger mr-2',
          visible: this.canDeny,
          click: () => this.onChangeStatus(userRequestStatuses.Denegada),
        },
        {
          label: 'Cancelar',
          icon: 'fas fa-times-circle text-danger mr-2',
          visible: this.canCancel,
          click: () => this.onChangeStatus(userRequestStatuses.Cancelada),
        },
      ];
      let actionEnter = {
        label: 'Entrar',
        border: this.disabled ? '' : 'bottom',
        icon: 'fas fa-file-import text-green mr-2',
        click: () => this.goToRequestCreation(),
        visible: this.hasActionsPermission,
      };
      let doneElement = { class: 'd-none' };
      let actionCancel = allAction[2];
      let history = {
        label: 'Historial',
        icon: 'fas fa-history text-success mr-2',
        click: () => this.onOpenHistory(),
      };
      let actions = [];

      if (!this.isApproved && !this.readonly && this.hasActionsPermission) {
        actions = [actionEnter, history, doneElement, ...allAction];
      }
      switch (this.model.statusId) {
        case userRequestStatuses.Sometida:
          actions = [actionEnter, history, doneElement, ...allAction];

          break;
        case userRequestStatuses.Aprobada:
          actions = [actionEnter, history, doneElement, actionCancel];
          break;
        case userRequestStatuses.Cancelada:
          actions = [actionEnter, history, doneElement];
          break;
        case userRequestStatuses.Denegada:
          actions = [actionEnter, history, doneElement, actionCancel];
          break;
      }
      return () => actions;
    },
    readonly() {
      return this.model.statusId == userRequestStatuses.Cancelada;
    },
    isSubmitted() {
      return this.model.statusId == userRequestStatuses.Sometida;
    },
    isApproved() {
      return this.model.statusId == userRequestStatuses.Aprobada;
    },
    checkInteractionMode() {
      return (mode) => this.interactionMode === mode;
    },
    canApprove() {
      return this.userHasPermissions('security.user.approve');
    },
    canDeny() {
      return this.userHasPermissions('security.user.deny');
    },
    canCancel() {
      return this.userHasPermissions('security.user.cancel');
    },
    noStatusChange() {
      return this.interactionMode === 'history';
    },
    getTitleMode() {
      switch (this.interactionMode) {
        case userRequestStatuses.Aprobada:
          return 'Información de Aprobación';
        case userRequestStatuses.Denegada:
          return 'Razón de Denegación';
        case userRequestStatuses.Cancelada:
          return 'Razón de Cancelación';
        default:
          return null;
      }
    },
  },
  mounted() {
    if (!this.isSubmitted) {
      this.interactionMode = this.model.statusId;
      this.reason = this.model.reason;
    }
  },
  methods: {
    getStatusClass(status) {
      switch (status) {
        case userRequestStatuses.Sometida:
          return 'submitted';
        case userRequestStatuses.Aprobada:
          return 'aproved';
        case userRequestStatuses.Cancelada:
          return 'canceled';
        case userRequestStatuses.Denegada:
          return 'rejected';
      }
    },
    getStatusName(status) {
      switch (status) {
        case userRequestStatuses.Sometida:
          return 'Sometida';
        case userRequestStatuses.Aprobada:
          return 'Aprobada';
        case userRequestStatuses.Cancelada:
          return 'Cancelada';
        case userRequestStatuses.Denegada:
          return 'Denegada';
      }
    },
    async onLoadMoreHandler() {
      this.pageSize = this.pageSize + DEFAULT_HISTORY_STATUS_PAGE_SIZE;
      await this.getAllHistory();
    },
    onChangeStatus(targetStatusId) {
      if (!this.model.userId) {
        this.openClose(false);
        this.interactionMode = targetStatusId;

        if (this.model.username)
          this.approveModel.username = this.model.username;
      } else {
        if (this.model.userIsActive) {
          this.Toast(
            'Error',
            `No es posible cambiar la determinación ya que el usuario tiene la cuenta activa en sistema.`,
            'error'
          );
          return;
        } else {
          this.openClose(false);
          this.interactionMode = targetStatusId;

          if (this.model.username)
            this.approveModel.username = this.model.username;
        }
      }
    },
    async onOpenHistory() {
      this.interactionMode = 'history';
      if (!this.canOpenCallout || this.noStatusChange) {
        this.openClose(false);
        this.getAllHistory();
      }
    },
    async getAllHistory() {
      let modelHistory = {
        requestId: this.model.requestAccountUserId,
        pageIndex: 1,
        pageSize: DEFAULT_HISTORY_STATUS_PAGE_SIZE,
      };
      const data = await _getHistory(modelHistory);
      this.historyItems = data.data;
      this.count = data.count;
    },
    goToRequestCreation() {
      this.$router.push({
        name: 'ManageRequest',
        params: { id: this.model.requestAccountUserId },
      });
    },
    async onSave() {
      var isValid = await this.$refs.reasonForm.validate();

      if (isValid) {  
        let dateobj = new Date();     
        const dto = {
          requestAccountUserId: this.model.requestAccountUserId,
          statusId: this.interactionMode,
          reason: this.reason,
          dateChange: dateobj.toLocaleString()
        };
        this.$emit('on-change-status', dto, this.approveModel);
      }
    },
    onCancel() {
      this.reason = null;
      this.openClose();
      this.interactionMode = 0;
    },
    openCalloutHandler() {
      this.interactionMode = 'history';
      this.openClose();
      if (!this.model.isOpen) this.getAllHistory();
    },
    openClose(value) {
      const state = value ?? this.model.isOpen;
      this.$emit('on-open-close', state);
    },
    setErrors(errors) {
      this.$refs.reasonForm.setErrors(errors);
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/sass/config/_colors.scss';

.activity-indicator {
  border-radius: 20px;
  font: Bold 16px/28px Lato;
  padding: 2.5px 6px;
  text-align: center;
  color: #11291b;
  width: auto !important;
}
.container-status {
  height: 15px;
  width: 15px;
  border-radius: 50%;
  display: inline-block;
  margin-top: 6px;
}
.container-status.submitted {
  background-color: #f8eb7f;
}

.container-status.aproved {
  background-color: #a3e5b3;
}

.container-status.canceled,
.container-status.rejected {
  background-color: #d5b89a;
}

.activity-indicator.submitted {
  background-color: #f8eb7f;
}

.activity-indicator.aproved {
  background-color: #a3e5b3;
}

.activity-indicator.canceled,
.activity-indicator.rejected {
  background-color: #d5b89a;
}

::v-deep .callout-submitted {
  border-left-color: #f8eb7f !important;
}

::v-deep .callout-aproved {
  border-left-color: #a3e5b3 !important;
}

::v-deep .callout-canceled,
::v-deep .callout-rejected {
  border-left-color: #d5b89a !important;
}

.reason-title {
  color: #3f5b60;
  margin-left: 0.5rem;
  font-weight: bold;
}

::v-deep .custom__text-area {
  .small-counter {
    text-align: right;
    font-size: 0.8rem;
    color: map-get($colors, 'gray-6');
  }
}

::v-deep .inline-grey-radio {
  .input-label {
    color: map-get($colors, 'gray-6');
    font-size: 0.875rem;
  }
}

.row-align-left {
  margin-left: 0.4rem;
}
.radius {
  padding: 8px;
  padding-top: 13px !important;
  width: 36px;
  height: 36px;
  text-align: center;
  background-color: #b5c3bc;
  border-radius: 50%;
  margin-left: 8px;
}
.ml-6 {
  margin-left: 3.5%;
}
</style>
